/*
 * pv-sort.js
 * ---------------------------------------------------------------------------
 * Sortierung in der Filterzeile des Collection-Grids.
 *
 * Bewusst ein voller Seitenaufruf statt eines Teil-Updates: die Sortierung
 * ändert die Reihenfolge aller Werke, also auch das, was nachgeladen wurde.
 * Ein Teil-Update müsste das Raster ohnehin komplett ersetzen.
 *
 * Aktive Filter bleiben erhalten, weil nur der Parameter sort_by gesetzt und
 * die Seitenzahl verworfen wird. Delegate auf dem Dokument, weil facets.js das
 * Raster samt Filterzeile bei jedem Filterwechsel austauscht.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  document.addEventListener('change', function (event) {
    var select = event.target;
    if (!select || !select.closest) return;
    if (!select.matches('[data-pv-sort-select]')) return;

    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
